// Deployment mode comes from /env.js (window.env.DEPLOYMENT_MODE). Anything other
// than "saas" — including unset — is treated as self-hosted, matching the backend.
export const isSaasDeployment = () => (window.env?.DEPLOYMENT_MODE || 'self-hosted') === 'saas';
